import { Skeleton } from '../ui/Skeleton';

export function NotificationItemSkeleton() {
  return (
    <div
      className="w-full px-3 py-2.5 border-b last:border-b-0 flex items-start gap-2"
      aria-hidden
    >
      {/* 아이콘 자리 */}
      <Skeleton circle className="h-4 w-4 shrink-0 mt-0.5" />

      {/* 메시지 + 날짜 */}
      <div className="flex-1 min-w-0 space-y-1.5">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-3 w-1/3" />
      </div>
    </div>
  );
}
